/* DRG CUSTOM (START) 20260420 | Mobile facets diff update v5.1 instant items */

(() => {
  if (window.__drgMobileFacetsDiffV51) return;
  window.__drgMobileFacetsDiffV51 = true;

  const MOBILE_MAX = 749;
  const requestState = new WeakMap();
  const debounceState = new WeakMap();

  function isMobile() {
    return window.innerWidth <= MOBILE_MAX;
  }

  function getRoot(target) {
    return target?.closest?.('[data-drg-mobile-facets]') || null;
  }

  function getForm(root) {
    return root?.querySelector('#DrgMobileFacetsForm') || null;
  }

  function getSheet(root) {
    return root?.querySelector('[data-drg-sheet]') || null;
  }

  function getOverlay(root) {
    return root?.querySelector('[data-drg-overlay]') || null;
  }

  function getScroll(root) {
    return root?.querySelector('.drg-mobile-facets-scroll') || null;
  }

  function getDynamic(root) {
    return root?.querySelector('[data-drg-dynamic]') || null;
  }

  function getChipContainer(root) {
    return root?.querySelector('[data-drg-dynamic-chips] .drg-mobile-facets-chips') || null;
  }

  function getOpenKeys(root) {
    return Array.from(root.querySelectorAll('.drg-mobile-group[open][data-group-key]'))
      .map((el) => el.getAttribute('data-group-key'))
      .filter(Boolean);
  }

  function setPersistedState(root, state) {
    root.dataset.drgOpenKeys = JSON.stringify(state.openKeys || []);
    root.dataset.drgSheetOpen = state.sheetOpen ? 'true' : 'false';
    root.dataset.drgScrollTop = String(state.scrollTop || 0);
  }

  function captureState(root) {
    const state = {
      openKeys: getOpenKeys(root),
      sheetOpen: !!getSheet(root)?.classList.contains('is-open'),
      scrollTop: getScroll(root)?.scrollTop || 0
    };
    setPersistedState(root, state);
    return state;
  }

  function applyOpenKeys(root, openKeys) {
    const wanted = new Set(openKeys || []);
    root.querySelectorAll('.drg-mobile-group[data-group-key]').forEach((group) => {
      const key = group.getAttribute('data-group-key');
      if (wanted.has(key)) {
        group.setAttribute('open', '');
      } else {
        group.removeAttribute('open');
      }
    });
  }

  let drgScrollLockY = 0;

  function lockPageScroll() {
    drgScrollLockY = window.scrollY || window.pageYOffset || 0;
    document.documentElement.classList.add('drg-mobile-facets-lock');
    document.body.classList.add('drg-mobile-facets-lock');
    document.body.style.top = `-${drgScrollLockY}px`;
  }

  function unlockPageScroll() {
    document.documentElement.classList.remove('drg-mobile-facets-lock');
    document.body.classList.remove('drg-mobile-facets-lock');
    document.body.style.top = '';
    window.scrollTo(0, drgScrollLockY);
  }

  function openSheet(root) {
    if (!root || !isMobile()) return;

    const overlay = getOverlay(root);
    const sheet = getSheet(root);
    const openBtn = root.querySelector('[data-drg-open]');

    if (overlay) overlay.hidden = false;
    if (sheet) {
      sheet.setAttribute('aria-hidden', 'false');
      sheet.classList.add('is-open');
    }
    if (openBtn) openBtn.setAttribute('aria-expanded', 'true');

    root.dataset.drgSheetOpen = 'true';
    lockPageScroll();
  }

  function closeSheet(root) {
    if (!root) return;

    const overlay = getOverlay(root);
    const sheet = getSheet(root);
    const openBtn = root.querySelector('[data-drg-open]');

    if (overlay) overlay.hidden = true;
    if (sheet) {
      sheet.setAttribute('aria-hidden', 'true');
      sheet.classList.remove('is-open');
    }
    if (openBtn) openBtn.setAttribute('aria-expanded', 'false');

    root.dataset.drgSheetOpen = 'false';
    unlockPageScroll();
  }

  function serializeForm(form) {
    const formData = new FormData(form);
    const params = new URLSearchParams();

    for (const [key, value] of formData.entries()) {
      if (value === '' || value == null) continue;
      params.append(key, value.toString());
    }

    return params;
  }

  function getSelectedCount(root) {
    const checkedCount = root.querySelectorAll('.drg-mobile-native-checkbox:checked').length;
    const priceInputs = root.querySelectorAll('.drg-mobile-price-input');
    const hasPrice = Array.from(priceInputs).some((input) => String(input.value || '').trim() !== '');
    return checkedCount + (hasPrice ? 1 : 0);
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function syncChipRowState(root) {
    const chipsRow = root.querySelector('[data-drg-dynamic-chips]');
    const chipsWrap = getChipContainer(root);

    if (!chipsRow || !chipsWrap) return;

    const hasChip = chipsWrap.children.length > 0;
    chipsRow.classList.toggle('is-empty', !hasChip);
  }

  function getCheckedChipData(root) {
    const chips = [];

    root.querySelectorAll('.drg-mobile-native-checkbox:checked').forEach((input) => {
      const label = input.closest('label')?.querySelector('.drg-mobile-native-text')?.textContent?.trim();
      if (!label) return;

      chips.push({
        type: 'checkbox',
        label,
        inputId: input.id
      });
    });

    const priceInputs = root.querySelectorAll('.drg-mobile-price-input');
    if (priceInputs.length === 2) {
      const minInput = priceInputs[0];
      const maxInput = priceInputs[1];
      const minVal = String(minInput.value || '').trim();
      const maxVal = String(maxInput.value || '').trim();

      if (minVal || maxVal) {
        const fallbackMax =
          String(maxInput.getAttribute('max') || '').trim() ||
          String(minInput.getAttribute('max') || '').trim();

        chips.push({
          type: 'price',
          label: `${minVal || '0'} - ${maxVal || fallbackMax || '0'}`
        });
      }
    }

    return chips;
  }

  function syncChipsInstant(root) {
    const chipsWrap = getChipContainer(root);
    if (!chipsWrap) return;

    const chips = getCheckedChipData(root);

    if (!chips.length) {
      chipsWrap.innerHTML = '';
      syncChipRowState(root);
      return;
    }

    chipsWrap.innerHTML = chips.map((chip) => {
      if (chip.type === 'checkbox') {
        return `
          <button
            type="button"
            class="drg-mobile-chip"
            data-drg-chip-local
            data-drg-chip-input-id="${escapeHtml(chip.inputId)}"
          >
            <span>${escapeHtml(chip.label)}</span>
            <span class="drg-mobile-chip__x">×</span>
          </button>
        `;
      }

      return `
        <button
          type="button"
          class="drg-mobile-chip"
          data-drg-chip-local
          data-drg-chip-price="true"
        >
          <span>${escapeHtml(chip.label)}</span>
          <span class="drg-mobile-chip__x">×</span>
        </button>
      `;
    }).join('');

    syncChipRowState(root);
  }

  function syncSelectedInstant(root) {
  const selectedCount = getSelectedCount(root);

  const triggerSelectedNode =
    root.querySelector('[data-drg-trigger-selected]');

  if (triggerSelectedNode) {
    triggerSelectedNode.textContent =
      `${selectedCount} selected`;

    triggerSelectedNode.classList.toggle(
      'is-hidden',
      selectedCount === 0
    );
  }
}

  function syncUiInstant(root) {
    syncSelectedInstant(root);
    syncChipsInstant(root);
  }

  function applyItemsCount(root, countText) {
    if (countText == null || countText === '') return;

    const normalized = String(countText).trim();
    const countNumber = Number(normalized);

    const headerItemsNode = root.querySelector('[data-drg-header-items-count]');
    const footerItemsNode = root.querySelector('[data-drg-items-count]');
    const headerItemsLabelNode = root.querySelector('[data-drg-header-items-label]');
    const footerItemsLabelNode = root.querySelector('[data-drg-items-label]');

    if (headerItemsNode) headerItemsNode.textContent = normalized;
    if (footerItemsNode) footerItemsNode.textContent = normalized;

    const label = countNumber === 1 ? 'Item' : 'Items';

    if (headerItemsLabelNode) headerItemsLabelNode.textContent = label;
    if (footerItemsLabelNode) footerItemsLabelNode.textContent = label;
  }

  function updateItemsInstantFromInput(root, input) {
    if (!root || !input || !input.matches('.drg-mobile-native-checkbox')) return;

    const label = input.closest('label');
    if (!label) return;

    const countNode = label.querySelector('.drg-mobile-native-count');
    if (!countNode) return;

    const raw = countNode.textContent.trim();
    const count = Number(raw.replace(/[^\d]/g, ''));
    if (Number.isNaN(count)) return;

    const currentHeader = root.querySelector('[data-drg-header-items-count]');
    const currentValue = Number((currentHeader?.textContent || '').replace(/[^\d]/g, ''));

    if (Number.isNaN(currentValue)) {
      applyItemsCount(root, count);
      return;
    }

    // 増える時の違和感を避けるため、減る方向と同値だけ即反映
    if (count <= currentValue) {
      applyItemsCount(root, count);
    }
  }

  function getIncomingItemsCount(incomingRoot) {
    const footerItemsNode = incomingRoot.querySelector('[data-drg-items-count]');
    if (footerItemsNode) return (footerItemsNode.textContent || '').trim();

    const headerItemsNode = incomingRoot.querySelector('[data-drg-header-items-count]');
    if (headerItemsNode) return (headerItemsNode.textContent || '').trim();

    return null;
  }

  function syncPageFromDoc(doc) {
    const gridSelectors = [
      '#ProductGridContainer',
      'results-list.section.product-grid-container',
      '.product-grid-container',
      '#main-collection-product-grid',
      '#ProductGrid'
    ];

    for (const selector of gridSelectors) {
      const current = document.querySelector(selector);
      const incoming = doc.querySelector(selector);
      if (current && incoming) {
        current.outerHTML = incoming.outerHTML;
        break;
      }
    }

    const countCurrent =
      document.querySelector('.product-count[role="status"] #ProductCount') ||
      document.querySelector('.product-count[role="status"] #ProductCountDesktop') ||
      document.querySelector('.product-count[role="status"]');

    const countIncoming =
      doc.querySelector('.product-count[role="status"] #ProductCount') ||
      doc.querySelector('.product-count[role="status"] #ProductCountDesktop') ||
      doc.querySelector('.product-count[role="status"]');

    if (countCurrent && countIncoming) {
      countCurrent.innerHTML = countIncoming.innerHTML;
    }
  }

  function buildDynamicSnapshot(incomingDynamic) {
    const snapshot = {
      groups: new Map(),
      sortValue: null
    };

    if (!incomingDynamic) return snapshot;

    incomingDynamic.querySelectorAll('.drg-mobile-group[data-group-key]').forEach((group) => {
      const groupKey = group.getAttribute('data-group-key') || '';
      const groupData = {
        items: new Map(),
        sortValue: null
      };

      group.querySelectorAll('.drg-mobile-native-checkbox').forEach((input) => {
        const itemKey = `${input.name}::${input.value}`;
        const label = input.closest('label');
        const countNode = label?.querySelector('.drg-mobile-native-count');
        const textNode = label?.querySelector('.drg-mobile-native-text');

        groupData.items.set(itemKey, {
          name: input.name,
          value: input.value,
          checked: !!input.checked,
          disabled: !!input.disabled,
          countText: countNode ? countNode.textContent.trim() : '',
          labelText: textNode ? textNode.textContent.trim() : ''
        });
      });

      const sortSelect = group.querySelector('select[name="sort_by"]');
      if (sortSelect) {
        groupData.sortValue = sortSelect.value;
        snapshot.sortValue = sortSelect.value;
      }

      snapshot.groups.set(groupKey, groupData);
    });

    return snapshot;
  }

  function applyDynamicSnapshot(root, snapshot) {
    if (!root || !snapshot) return;

    root.querySelectorAll('.drg-mobile-group[data-group-key]').forEach((currentGroup) => {
      const groupKey = currentGroup.getAttribute('data-group-key') || '';
      const incomingGroup = snapshot.groups.get(groupKey);
      if (!incomingGroup) return;

      currentGroup.querySelectorAll('.drg-mobile-native-checkbox').forEach((input) => {
        const itemKey = `${input.name}::${input.value}`;
        const incomingItem = incomingGroup.items.get(itemKey);
        if (!incomingItem) return;

        const label = input.closest('label');
        const countNode = label?.querySelector('.drg-mobile-native-count');

        if (countNode && incomingItem.countText !== '') {
          countNode.textContent = incomingItem.countText;
        }

        input.disabled = !!incomingItem.disabled;

        if (label) {
          label.classList.toggle('is-disabled', !!incomingItem.disabled);
        }
      });

      const currentSort = currentGroup.querySelector('select[name="sort_by"]');
      if (currentSort && incomingGroup.sortValue != null) {
        currentSort.value = incomingGroup.sortValue;
      }
    });
  }

  async function replacePreview(root, url, options = {}) {
    const previousController = requestState.get(root);
    if (previousController) previousController.abort();

    const controller = new AbortController();
    requestState.set(root, controller);

    const state = captureState(root);
    const scroll = getScroll(root);
    const prevScrollTop = scroll ? scroll.scrollTop : 0;

    const preserveUserScroll = options.preserveUserScroll !== false;
    let userScrolledDuringRequest = false;
    let liveScrollTop = prevScrollTop;

    const handleUserScrollDuringRequest = () => {
      if (!preserveUserScroll) return;
      const currentScroll = getScroll(root);
      if (!currentScroll) return;

      liveScrollTop = currentScroll.scrollTop;
      if (Math.abs(liveScrollTop - prevScrollTop) > 4) {
        userScrolledDuringRequest = true;
      }
    };

    if (scroll && preserveUserScroll) {
      scroll.addEventListener('scroll', handleUserScrollDuringRequest, { passive: true });
    }

    try {
      const response = await fetch(url, {
        signal: controller.signal,
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });

      if (!response.ok) return;

      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const incomingRoot = doc.querySelector('[data-drg-mobile-facets]');
      if (!incomingRoot) return;

      const incomingItemsCount = getIncomingItemsCount(incomingRoot);
      const incomingDynamic = incomingRoot.querySelector('[data-drg-dynamic]');
      const snapshot = buildDynamicSnapshot(incomingDynamic);

      applyItemsCount(root, incomingItemsCount);

      requestAnimationFrame(() => {
        const dynamic = getDynamic(root);
        if (dynamic) {
          dynamic.style.display = 'none';
        }

        applyDynamicSnapshot(root, snapshot);

        if (dynamic) {
          dynamic.style.display = '';
        }

        applyOpenKeys(root, state.openKeys || []);

        const nextScroll = getScroll(root);
        if (nextScroll) {
          nextScroll.scrollTop = userScrolledDuringRequest ? liveScrollTop : prevScrollTop;
        }

        requestAnimationFrame(() => {
          syncUiInstant(root);
          syncPageFromDoc(doc);
          window.history.replaceState({}, '', url);
        });
      });
    } catch (error) {
      if (error.name !== 'AbortError') {
        console.error('DRG mobile facets diff update failed:', error);
      }
    } finally {
      if (scroll && preserveUserScroll) {
        scroll.removeEventListener('scroll', handleUserScrollDuringRequest);
      }

      if (requestState.get(root) === controller) {
        requestState.delete(root);
      }
    }
  }

  function debouncePreview(root, delay = 160, options = {}) {
    const existing = debounceState.get(root);
    if (existing) window.clearTimeout(existing.timer);

    const timer = window.setTimeout(() => {
      const form = getForm(root);
      if (!form) return;

      const params = serializeForm(form);
      const qs = params.toString();
      const url = qs ? `${window.location.pathname}?${qs}` : window.location.pathname;

      replacePreview(root, url, options);
      debounceState.delete(root);
    }, delay);

    debounceState.set(root, { timer, options });
  }

  function clearAllInputsLocal(root) {
    root.querySelectorAll('.drg-mobile-native-checkbox:checked').forEach((input) => {
      input.checked = false;
    });

    root.querySelectorAll('.drg-mobile-price-input').forEach((input) => {
      input.value = '';
    });
  }

  document.addEventListener('click', (event) => {
    const root = getRoot(event.target);
    if (!root) return;

    const openBtn = event.target.closest('[data-drg-open]');
    if (openBtn) {
      event.preventDefault();
      openSheet(root);
      return;
    }

    const closeBtn = event.target.closest('[data-drg-close]');
    if (closeBtn) {
      event.preventDefault();
      closeSheet(root);
      return;
    }

    const overlay = event.target.closest('[data-drg-overlay]');
    if (overlay) {
      event.preventDefault();
      closeSheet(root);
      return;
    }

    const localChip = event.target.closest('[data-drg-chip-local]');
    if (localChip) {
      event.preventDefault();

      const inputId = localChip.getAttribute('data-drg-chip-input-id');
      const isPrice = localChip.hasAttribute('data-drg-chip-price');

      if (inputId) {
        const input = root.querySelector(`#${CSS.escape(inputId)}`);
        if (input) {
          input.checked = false;
          syncUiInstant(root);
          debouncePreview(root, 120, { preserveUserScroll: true });
        }
        return;
      }

      if (isPrice) {
        root.querySelectorAll('.drg-mobile-price-input').forEach((input) => {
          input.value = '';
        });
        syncUiInstant(root);

        const form = getForm(root);
        const params = serializeForm(form);
        const qs = params.toString();
        const url = qs ? `${window.location.pathname}?${qs}` : window.location.pathname;

        replacePreview(root, url, { preserveUserScroll: false });
        return;
      }
    }

    const chipLink = event.target.closest('[data-drg-chip-link]');
    if (chipLink) {
      event.preventDefault();
      replacePreview(root, chipLink.href, { preserveUserScroll: true });
      return;
    }

    const clearAll = event.target.closest('[data-drg-clear-all]');
    if (clearAll) {
      event.preventDefault();
      clearAllInputsLocal(root);
      syncUiInstant(root);
      replacePreview(root, clearAll.href, { preserveUserScroll: true });
      return;
    }

    const seeItems = event.target.closest('[data-drg-see-items]');
    if (seeItems) {
      event.preventDefault();
      closeSheet(root);
      return;
    }
  });

  document.addEventListener('toggle', (event) => {
    const group = event.target;
    if (!group.matches?.('.drg-mobile-group[data-group-key]')) return;

    const root = getRoot(group);
    if (!root) return;

    captureState(root);
  });

  document.addEventListener('change', (event) => {
    const root = getRoot(event.target);
    if (!root || !isMobile()) return;

    const target = event.target;

    if (
      target.matches('.drg-mobile-native-checkbox') ||
      target.matches('.drg-mobile-price-input') ||
      target.matches('select[name="sort_by"]')
    ) {
      syncUiInstant(root);

      if (target.matches('.drg-mobile-price-input')) {
        debouncePreview(root, 120, { preserveUserScroll: false });
      } else {
        updateItemsInstantFromInput(root, target);
        debouncePreview(root, 120, { preserveUserScroll: true });
      }
    }
  });

  document.addEventListener('input', (event) => {
    const root = getRoot(event.target);
    if (!root || !isMobile()) return;

    const target = event.target;
    if (target.matches('.drg-mobile-price-input')) {
      syncUiInstant(root);
      return;
    }
  });

  document.addEventListener('keydown', (event) => {
    const root = getRoot(event.target);
    if (!root || !isMobile()) return;

    const target = event.target;
    if (!target.matches('.drg-mobile-price-input')) return;

    if (event.key === 'Enter') {
      event.preventDefault();
      syncUiInstant(root);
      debouncePreview(root, 0, { preserveUserScroll: false });
    }
  });

  function initRoot(root) {
    closeSheet(root);
    setPersistedState(root, { openKeys: [], sheetOpen: false, scrollTop: 0 });
    applyOpenKeys(root, []);
    syncUiInstant(root);
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-drg-mobile-facets]').forEach(initRoot);
  });

  document.addEventListener('shopify:section:load', () => {
    document.querySelectorAll('[data-drg-mobile-facets]').forEach(initRoot);
  });

  window.addEventListener('resize', () => {
    if (isMobile()) return;
    document.querySelectorAll('[data-drg-mobile-facets]').forEach((root) => {
      closeSheet(root);
    });
  });
})();

/* DRG CUSTOM (END) 20260420 | Mobile facets diff update v5.1 instant items */